import api from './api';
import {
    CategoryValueResponse,
    SingleCategoryValueResponse,
    CategoryValueSyncStatusResponse
} from '../types/categoryValue';

export const getCategoryValues = async (params?: {
    page?: number;
    limit?: number;
    search?: string;
    catName?: string;
}): Promise<CategoryValueResponse> => {
    const response = await api.get('/category-values', { params });
    return response.data;
};

export const getCategoryValueById = async (id: string | number): Promise<SingleCategoryValueResponse> => {
    const response = await api.get(`/category-values/${id}`);
    return response.data;
};

export const syncCategoryValues = async (): Promise<{ success: boolean; message: string }> => {
    const response = await api.post('/category-values/sync');
    return response.data;
};

export const getCategoryValueSyncStatus = async (): Promise<CategoryValueSyncStatusResponse> => {
    const response = await api.get('/category-values/sync/status');
    return response.data;
};

// Toggle Top Rated for a Category Value (Subcategory) - PATCH /api/site/category-values/:id/toggle-top-rated
export const toggleTopRated = async (id: string | number): Promise<{ success: boolean; message?: string; data?: any }> => {
    const response = await api.patch(`/category-values/${id}/toggle-top-rated`);
    return response.data;
};
